import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { ArrowDownToLine, ArrowUpFromLine, Wallet } from "lucide-react";
import { TerminalShell } from "@/components/TerminalShell";
import { tradingService } from "@/services/marketService";
import { fmtMoney } from "@/lib/format";
import { useLanguage } from "@/context/LanguageContext";

export default function FundsPage() {
  const { t } = useLanguage();
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    tradingService.summary().then(setSummary).catch(() => setSummary(null));
  }, []);

  const items = [
    { to: "/deposit", label: t("funds.deposit"), icon: ArrowDownToLine, description: t("funds.depositDesc"), testId: "funds-deposit-card" },
    { to: "/withdraw", label: t("funds.withdraw"), icon: ArrowUpFromLine, description: t("funds.withdrawDesc"), testId: "funds-withdraw-card" },
  ];

  return (
    <TerminalShell account={summary}>
      <div data-testid="funds-page" className="p-4 sm:p-8">
        <div className="max-w-3xl space-y-6">
          <div className="rounded-md border border-[#141A26] bg-[#0A0E16] p-6">
            <p className="flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] text-[#8A97AD]">
              <Wallet className="h-3.5 w-3.5 text-[#5B9CFF]" /> {t("funds.balance")}
            </p>
            <p className="mt-3 font-mono text-2xl text-white" data-testid="funds-balance">
              {fmtMoney(summary?.balance)}
            </p>
            <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.2em] text-[#5C6B82]">
              {t("funds.free")} {fmtMoney(summary?.free_margin)} · {t("funds.used")} {fmtMoney(summary?.used_margin)}
            </p>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {items.map((i) => (
              <Link
                key={i.to}
                to={i.to}
                data-testid={i.testId}
                className="group rounded-md border border-[#141A26] bg-[#0A0E16] p-6 transition-colors hover:border-[#2563EB]/50"
              >
                <i.icon className="h-4 w-4 text-[#5B9CFF]" />
                <p className="mt-4 text-sm text-white">{i.label}</p>
                <p className="mt-2 text-xs leading-relaxed text-[#8A97AD]">{i.description}</p>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </TerminalShell>
  );
}
